<template>
  <div class="policyList">
    <div class="policyList-header">
      <topHeader
        :label="label"
        :textColor="textColor"
        :leftSrc="leftSrc"
        :backgroundColor="backgroundColor"
      ></topHeader>
    </div>
    <div class="bility-select">
      <searchInput @goSearch="goSearch" :placeholder="placeholder"></searchInput>
    </div>
    <div
      class="policyList-box"
      @touchstart.stop="touchstart"
      @touchmove.stop="touchmove"
      @touchend.stop="touchend"
      ref="scrollAdd"
    >
      <div
        class="policyList-box-div"
        v-for="(policy, index) in policyList"
        :key="index"
        @click="goPolicyInfos(policy.Id)"
      >
        <div class="policyList-box-title">{{policy.Title}}</div>
        <div class="policyList-box-time">{{policy.Createdate | dataFilter}}</div>
      </div>
      <transition name="bounce">
        <div class="loading_add" v-show="loading">
          <img src="./../../assets/loading.png" />
          <!-- <span class="iconfont icon-jiazai1-copy-copy"></span> -->
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header.vue";
import searchInput from "@/components/searchInput.vue";
export default {
  data() {
    return {
      label: "政策文件列表",
      backgroundColor: "#ffffff",
      textColor: "#333333",
      leftSrc: require("@/assets/ico@2x.png"),
      policyList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      keyword: "",
      placeholder: "请输入政策关键字"
    };
  },
  components: {
    topHeader,
    searchInput
  },
  methods: {
    touchstart(e) {
      let touch = e.changedTouches[0];
      this.beginY = touch.clientY;
    },
    touchmove() {
      let scrollTop = this.$refs.scrollAdd.scrollTop;
      let clientHeight = this.$refs.scrollAdd.clientHeight;
      let scrollHeight = this.$refs.scrollAdd.scrollHeight;
      let bottomHeight = scrollHeight - clientHeight - scrollTop;
      // if (bottomHeight == 0 && this.list.length > 0) {
      this.loading = true;
      // }
    },
    touchend(e) {
      let endTouch = e.changedTouches[0];
      if (this.beginY > endTouch.clientY) {
        if (this.loading) {
          this.page++;
          this.initGetPolicyList();
        }
      }
    },
    goPolicyInfos(Id) {
      this.$router.push({
        path: "policyInfos",
        query: { Id: Id }
      });
    },
    initGetPolicyList() {
      this.$axios({
        url: "api/getArticleList",
        type: "get",
        params: {
          areacode: "00",
          page: this.page,
          pageSize: this.pageSize,
          keyword: this.keyword
        }
      })
        .then(res => {
          this.policyList = this.policyList.concat(res.data.articleList);
          this.loading = false;
        })
        .catch(err => {
          console.info(err);
        });
    },
    goSearch(value) {
      this.keyword = value;
      this.page = 1;
      this.initGetPolicySearch();
    },
    initGetPolicySearch() {
      this.$axios({
        url: "api/getArticleList",
        type: "get",
        params: {
          areacode: "00",
          page: this.page,
          pageSize: this.pageSize,
          keyword: this.keyword
        }
      })
        .then(res => {
          this.policyList = res.data.articleList;
          this.loading = false;
        })
        .catch(err => {
          console.info(err);
        });
    }
  },
  mounted() {
    this.initGetPolicyList();
  },
  filters: {
    dataFilter: function(value) {
      let time = value.substring(value.indexOf("(") + 1, value.length - 2);
      let date = new Date(Number(time));
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return `${year}-${month < 10 ? "0" + month : month}-${day}`;
    }
  },
  watch: {
    policyList(newValue, oldValue) {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.policyList {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  .policyList-header {
    width: 100%;
    height: auto;
  }
  .bility-select {
    width: 100%;
    height: 2rem;
    display: flex;
    line-height: 2rem;
    padding: 0 1rem;
    margin-top: 1rem;
    // .bility-lable {
    //   width: 100%;
    //   height: 2rem;
    //   flex: 2;
    //   font-size: 0.8rem;
    // }
    // .bility-input {
    //   width: 100%;
    //   height: 2rem;
    //   flex: 4;
    //   // border: 1px solid #e0e0e0;
    //   border-radius: 0.16rem;
    //   background-color: #dcdcdc;
    //   position: relative;
    //   input {
    //     width: 100%;
    //     height: 2rem;
    //     border: 0;
    //     background-color: transparent;
    //     outline: none;
    //     padding: 0 1rem 0 1.5rem;
    //   }
    //   img {
    //     position: absolute;
    //     width: 0.81rem;
    //     height: 0.81rem;
    //     top: 0;
    //     bottom: 0;
    //     right: 0.5rem;
    //     margin: auto;
    //     z-index: 50;
    //   }
    // }
    // .bility-btn {
    //   width: 100%;
    //   height: 2rem;
    //   flex: 1;
    //   a {
    //     border: 1px solid #e0e0e0;
    //     padding: 0.25rem;
    //     font-size: 0.7rem;
    //     text-decoration: none;
    //     border-radius: 0.5rem;
    //   }
    // }
  }
  .policyList-box {
    width: 100%;
    height: 100%;
    // padding: 0.5rem 1rem 3rem 1rem;
    // margin-bottom: 3rem;
    .policyList-box-div {
      width: 100%;
      height: auto;
      // display: flex;
      // border: 1px solid #cccccc;
      // border-radius: 0.5rem;
      // box-shadow: 0 0.08rem 0.1rem #212121;
      box-shadow: 0rem 0.08rem 0rem 0rem rgba(0, 0, 0, 0.07);
      // border-bottom: 0.08rem solid rgba();
      padding: 0.5rem 1rem;
      margin: 0.5rem 0;
      .policyList-box-title {
        width: 100%;
        line-height: 1rem;
        font-size: 0.8rem;
        text-align: left;
        // padding: 0 0.8rem;
        position: relative;
        color: #999999;
        // &::before {
        //   content: "";
        //   position: absolute;
        //   left: 0.25rem;
        //   width: 0.25rem;
        //   height: 1rem;
        //   background-color: #ff0000;
        //   top: 0;
        //   bottom: 0;
        //   margin: auto;
        // }
      }
      .policyList-box-time {
        width: 100%;
        height: 1rem;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        font-size: 0.75rem;
        line-height: 1rem;
        text-align: left;
        color: #c7c7c7;
      }
    }
  }
}
</style>